import React, { useEffect, useRef, useState } from 'react';


import { Button, Tabs, Tab } from 'react-bootstrap';

const CommonGrid = ({ GD, onAction, detailsData, activeTab, setActiveTab, gridSelect, setGridSelect, reload }) => {

    const isMounted = useRef(false);
    let gridRef = useRef(null);

    const tabs = GD?.Tabs || [];
    let gridRefs = useRef({})
    if (tabs.length) {
        tabs.forEach(tab => {
            if (!gridRefs.current[tab]) {
                gridRefs.current[tab] = React.createRef();
            }
        });
    }

    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(true);
    // const [activeTab, setActiveTab] = useState(GD?.ActiveTab || tabs[0] || '');
    const [propData, setPropData] = useState(true);
    const [gridData, setGridData] = useState(GD.TabName || []);
    // const [gridSelect, setGridSelect] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState();
    const [filterApplied, setFilterApplied] = useState(false);



    useEffect(() => {
        if (isMounted.current) return;
        if (GD.localData) { setDisLoading(false) }
        setIsLoading(false);
        setGridData([]);
        setPropData(GD)
        isMounted.current = true;
    }, []);

    useEffect(() => {
        if (reload) {
            if (GD.localData) { setDisLoading(false) }
            setIsLoading(false);
            setGridData([]);
        }


    }, [reload]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setGridSelect([]);
        checkUlds = [];
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setGridData([]);
        }, 10);
    };

    let checkUlds = [];
    let filterForCheck = false;
    // console.log('gridRef', gridRef);
    useEffect(() => {
        const originalOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url, ...args) {
            originalOpen.call(this, method, url, ...args);
            if (url.includes(process.env.REACT_APP_RFS_URL)) {
                this.withCredentials = true;
            }
        };

        const refComp = propData?.Tabs && propData.Tabs.length > 0 ? window.$(gridRefs.current[activeTab].current) : window.$(gridRef.current)
        // console.log('refComp', refComp);
        const refCheck = propData?.Tabs && propData.Tabs.length > 0 ? gridRefs.current[activeTab].current : gridRef.current
        if (refCheck) {
            const key = GD.EndPoint
            // console.log('tk', localStorage.tk);

            let dataUrl = ``;
            if (GD.Tabs) {
                dataUrl = `${process.env.REACT_APP_RFS_URL}${GD.EndPoint}${GD.TabMap[activeTab]}`
            } else {
                dataUrl = `${process.env.REACT_APP_RFS_URL}${GD.EndPoint}`
            }

            // var token = "Bearer " + localStorage.getItem(GD.Token);

            // const credentialedXhr = () => {
            //     const xhr = new XMLHttpRequest();
            //     xhr.withCredentials = true;
            //     return xhr;
            // };
            const source = key ? {
                url: dataUrl,
                // xhr: credentialedXhr,
                beforeSend: function (jqXHR) {
                    // setLoaderModal(true);
                    jqXHR.withCredentials = true;
                    // jqXHR.setRequestHeader('Authorization', token);
                },
                id: '',
                datatype: 'json',
                datafields: GD.Datafields,
                pagesize: GD.Options.pageSize,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    refComp.jqxGrid('clearselection');
                    refComp.jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    // setLoaderModal(false);
                    setDisLoading(false)
                    source.totalrecords = data.TotalRows;
                    // setAlldata(data);
                    if (data.Rows.length && GD.page === 'allstn') {
                        detailsData(data.Rows[0])
                    }
                },
                sort: function (column, direction) {
                    refComp.jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            } : {
                datatype: 'json',
                id: `aaa-`,
                datafields: GD.Datafields,
                localdata: GD.localData,
            };
            console.log('GD.localData', GD.localData);

            const dataAdapter = new window.$.jqx.dataAdapter(source);

            const columns = GD.Columns;
            const nestedColumns = GD?.nestedColumns;
            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const id = record.uid.toString();
                const subKey = record[GD.nestedkey].toString();
                const uldGrid = !GD.nestedURL ? dataAdapter.loadedData?.ulds[id]?.uld_level : '';
                const nestedGridContainer = parentElement.children[0];
                parentElement.addEventListener("click", (event) => {
                    const target = event.target;
                    if (window.$(target).hasClass("jqx-icon-arrow-right")) {
                        event.stopPropagation();
                    }
                });
                let nestedSource = {
                    datatype: "json",
                    id: "shipmentChildID",
                    datafields: GD?.nestedDataFields,
                    localdata: uldGrid,
                };
                if (GD.nestedURL) {
                    const subendPoint = `${GD.nestedURL}${subKey}`
                    nestedSource = {
                        datatype: 'json',
                        id: 'shipmentChildID',
                        datafields: GD?.nestedDataFields,
                        url: `${process.env.REACT_APP_RFS_URL}${subendPoint}`,
                        // beforeSend: function (jqXHR) {
                        //     // jqXHR.setRequestHeader('Authorization', token);
                        //      jqXHR.withCredentials = true;
                        // },
                        pagesize: 50,
                        filter: function (allfilters) {
                            if (allfilters.length > 0) {
                                setFilterApplied(true);
                                filterForCheck = true;
                            } else {
                                setFilterApplied(false);
                                filterForCheck = false;
                            }
                            refComp.jqxGrid('clearselection');
                            refComp.jqxGrid("updatebounddata", "filter");
                        },
                        beforeprocessing: function (data) {
                            source.totalrecords = data.TotalRows;
                        },
                        sort: function () {
                            refComp.jqxGrid("updatebounddata", "sort");
                        },
                        root: "Rows",
                        cache: false,
                    }
                }
                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);
                const nestedGridOptions = {
                    width: "100%",
                    pageable: false,
                    sortable: false,
                    autoheight: true,
                    height: 15 * 45,
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };

            const filterCol = columns.filter(col => col.datafield !== 'buildup_status');
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: GD.Options.height,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: GD.Options.selectionmode,
                initrowdetails: GD.nested ? initrowdetails : '',
                pageable: true,
                pageSize: GD.Options.pageSize,
                pagesizeoptions: GD.Options.pagesizeoptions,
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rowdetails: GD.nested ?? false,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (5 * 45),
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = refComp.jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                refComp.jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            console.log('gridOptions', gridOptions);
            refComp.jqxGrid(gridOptions);

            // attachDelegatedTooltipHandlers();
            refComp.find('.jqx-grid-column-header').css('background-color', 'white');
            refComp.find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            refComp.on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow[GD.selectionID];
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.awb_id === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }

                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row[GD.selectionID] === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = refComp.jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            refComp.on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row[GD.selectionID];
                    setGridSelect(prevSelection => prevSelection.filter(row => row[GD.selectionID] !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });

            refComp.on('click', `.grid_actions`, function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = refComp.jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = refComp.jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

                    const rowData = refComp.jqxGrid('getrowdata', globalIndex);
                    // console.log('pos', event.target.className);

                    if (rowData) {
                        const sendData = { data: rowData, section: event.target.className, }
                        onAction(sendData);
                    }
                }
            });
            if (GD.rowClick) {
                refComp.on('rowclick', (event) => {
                    // console.log('event', event);
                    const args = event.args.row.bounddata;
                    // console.log('args', args);
                    const sendRowId = gridData;
                    detailsData(args);
                });
            }
            refComp.on('click', '.row_delete', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = refComp.jqxGrid('getrowdata', rowIndex);
                // handleModalOpen('G', rowData.awb_id);
            });
            refComp.off('cellclick');
            refComp.on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > GD.cellClickIndex) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            refComp.jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                    const sendData = { data: args, section: 'cellclick', }
                    if (GD.detailsApi) {
                        loadDetails(args[GD.dettailsParam]);

                    } else {
                        onAction(sendData)
                    }
                }
            });
        }
    }, [gridData]);

    const refComp = propData.tab > 0 ? window.$(gridRefs.current[activeTab].current) : window.$(gridRef.current)
    const resetFilters = () => {
        setTimeout(() => {
            refComp.jqxGrid('refresh');
        }, 30);
        refComp.jqxGrid('clearfilters');
    };
    const loadDetails = async (uldNumber) => {
        // setDisLoading(true);
        // try {
        //     const res = await withRFSToken.post('uld-control/build-up-details', { uld_id: String(uldNumber) });
        //     if (res.data.response_code === 200) {
        //         const innerData = res.data.response_data;
        //         const sendData = { data: innerData, section: 'cellclick', }
        //         onAction(innerData);
        //         resetFilters()
        //     } else {
        //         toast.error(res.data.response_msg);
        //     }
        //     setDisLoading(false);

        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    }

    return (
        <>
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {(!propData?.Tabs || propData.Tabs.length === 0) &&
                <div className='mt-3 position-relative'>
                    {/* {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>} */}
                    {!isLoading && <>
                        {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                        <div ref={gridRef} className='bookinggrid' ></div>
                    </>
                    }
                </div>
            }
            {propData?.Tabs && propData.Tabs.length > 0 && (
                <Tabs activeKey={activeTab} onSelect={handleTabChange} id="tabbed-grid" className="booking_tab">
                    {tabs.map((tab) => (
                        <Tab key={tab} eventKey={tab} title={<span>{tab}</span>} className="moveto">
                            {!isLoading && (
                                <>
                                    {filterApplied && (
                                        <div className="clear_filter">
                                            <Button onClick={resetFilters}>Reset Filters</Button>
                                        </div>
                                    )}
                                    <div ref={gridRefs.current[tab]} className="bookinggrid" />
                                </>
                            )}
                        </Tab>
                    ))}
                </Tabs>
            )}
        </>
    )
}

export default CommonGrid